import LegalEntityTable from "../../legalEntity/legalEntityTable/LegalEntityTable.tsx";
import React from "react";
import { DotLegalCheckbox } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation.ts";
import StepSegment from "../../processingActivity/stepSegment/StepSegment.tsx";
import { Box } from "@mui/system";
import LegalEntitySelectorDialog from "../../legalEntity/legalEntitySelectorDialog/LegalEntitySelectorDialog.tsx";
import { useGroupCompaniesField } from "./GroupCompaniesField.hooks.ts";

export interface GroupCompaniesChange {
    groupEntities: Array<string>;
    allGroupEntityAccess: boolean;
}

export interface GroupCompaniesFieldProps {
    groupEntities: Array<string>;
    isLoading: boolean;
    onChange: (change: GroupCompaniesChange) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
    addGroupEntityDialogHeader: string;
    allGroupEntityAccess: boolean;
    requireSelectionBeforeUncheck: boolean;
}

function GroupCompaniesField(props: GroupCompaniesFieldProps) {
    const { translateString } = useTranslation();
    const {
        allGroupEntities,
        isLoading,
        show,
        showTable,
        onAllGroupEntityAccessChange,
        onGroupEntitiesChange,
        showSelectorDialog,
        setShowSelectorDialog,
        entitiesSelectedInDialog,
        setEntitiesSelectedInDialog,
        dialogGridLength,
        setDialogGridLength,
        onSelectorDialogConfirm,
    } = useGroupCompaniesField(props);

    return (
        <>
            {show && (
                <Box data-group-companies-field sx={{ display: "flex", alignItems: props.isPreview ? "start" : "center", flexDirection: "column" }}>
                    <StepSegment size={"small"}>
                        <DotLegalCheckbox
                            checked={props.isPreview ? false : props.allGroupEntityAccess}
                            label={translateString("allGroupEntityAccess")}
                            margin={{ marginLeft: -1.5 }}
                            tooltip={translateString("allGroupEntityAccessTooltip")}
                            onChange={onAllGroupEntityAccessChange}
                            disabled={props.disabled}
                        />
                    </StepSegment>

                    {showTable && (
                        <Box width={props.isPreview ? "100%" : "90%"} mt={1}>
                            <LegalEntityTable
                                isLoading={isLoading}
                                legalEntities={allGroupEntities}
                                selectedEntities={props?.groupEntities ?? []}
                                showAddNewEntityButton={false}
                                showAddAllEntityButton
                                onLegalEntitiesChange={onGroupEntitiesChange}
                                addGroupEntityDialogHeader={props.addGroupEntityDialogHeader}
                                disabled={props.disabled}
                                errorText={props.errorText}
                                noLegalEntitiesSelectedHeader={translateString("noGroupCompaniesHaveAccess")}
                                disallowRemovingLastEntity={!props.allGroupEntityAccess}
                                disallowRemovingLastEntityTooltip={translateString("oneGroupCompanyIsRequired")}
                            />
                        </Box>
                    )}
                </Box>
            )}

            {showSelectorDialog && (
                <LegalEntitySelectorDialog
                    gridLength={dialogGridLength}
                    onGridChange={(gridLength: any) => setDialogGridLength(gridLength)}
                    allColumns
                    isLoading={isLoading}
                    buttonOkText={translateString("add")}
                    setShowDialog={setShowSelectorDialog}
                    dialogHeader={props.addGroupEntityDialogHeader}
                    legalEntityItems={allGroupEntities}
                    selectedEntities={entitiesSelectedInDialog}
                    setSelectedEntities={setEntitiesSelectedInDialog}
                    setOkClicked={() => onSelectorDialogConfirm()}
                    onCheckBoxChange={() => {}}
                    isChecked={false}
                />
            )}
        </>
    );
}

export default GroupCompaniesField;
